import { render } from "./CreateTypeConsultation.vue?vue&type=template&id=69241e40&scoped=true"
import script from "./CreateTypeConsultation.vue?vue&type=script&lang=js"
export * from "./CreateTypeConsultation.vue?vue&type=script&lang=js"

import "./CreateTypeConsultation.vue?vue&type=style&index=0&id=69241e40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69241e40"]])

export default __exports__